class Bullet {
	/**
	 * Generate a Base64 encoded SVG string for a rectangle.
	 * @param {Object} params - The parameters for the rectangle.
	 * @param {number} [params.width=20] - The width of the rectangle.
	 * @param {number} [params.height=20] - The height of the rectangle.
	 * @param {string} [params.color="#F97316"] - The fill color of the rectangle.
	 * @returns {string} Base64 encoded SVG string.
	 */
	static rectangle({ width = 20, height = 20, color = "#F97316" } = {}) {
		const svgString = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
        <rect width="${width}" height="${height}" style="fill:${color};"/>
      </svg>
    `;
		return "data:image/svg+xml;base64," + btoa(svgString);
	}

	/**
	 * Generate a Base64 encoded SVG string for a polygon with an outline.
	 * @param {Object} params - The parameters for the polygon.
	 * @param {number} [params.size=20] - The width and height of the SVG.
	 * @param {number} [params.rotation=0] - The rotation of the polygon.
	 * @param {number} [params.count=3] - The number of sides (default is a triangle).
	 * @param {string} [params.fill="transparent"] - The fill color of the polygon.
	 * @param {string} [params.strokeColor="black"] - The outline color of the polygon.
	 * @param {number} [params.strokeWidth=2.5] - The width of the outline stroke.
	 * @returns {string} Base64 encoded SVG string.
	 */
	static polygon({
		size = 20,
		rotation = 0,
		count = 3,
		fill = "transparent",
		strokeColor = "black",
		strokeWidth = 2.5,
	} = {}) {
		const radius = size / 2;
		const angle = (2 * Math.PI) / count;
		const points = Array.from({ length: count }, (_, i) => {
			const x = radius + radius * Math.cos(i * angle);
			const y = radius - radius * Math.sin(i * angle);
			return `${x},${y}`;
		}).join(" ");

		const svgString = `
          <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
            <polygon points="${points}" fill="${fill}" stroke="${strokeColor}" stroke-width="${strokeWidth}" transform="rotate(${rotation}, ${
			size / 2
		}, ${size / 2})" />
          </svg>
        `;
		return "data:image/svg+xml;base64," + btoa(svgString);
	}
}

export default Bullet;
